import { Circle } from '@vis.gl/react-google-maps';
import React from 'react';
import { MAP_CIRCLE_OPTIONS, milesToMeters } from './zoneMapConfig';

export interface ZoneCircleProps {
    latitude: number;
    longitude: number;
    radiusMiles: number;
}

export const ZoneCircle: React.FC<ZoneCircleProps> = ({ latitude, longitude, radiusMiles }) => {
    return (
        <Circle
            center={{ lat: latitude, lng: longitude }}
            radius={milesToMeters(radiusMiles)}
            {...MAP_CIRCLE_OPTIONS}
        />
    );
};
